import React from 'react';
import './PageNavigationLinks.scss';

const PageNavigationLinks = props => {
  return (
    <ul className="parkchirp--page-navigation-links">
      {props.children}
    </ul>
  );
};

export default PageNavigationLinks;
